import { getRecipes, getRecipeDetails, getAllRecipes } from "./recipes";
import { registerUser, loginUser, loginWithGoogle, completeOAuthLogin, isUserLoggedIn, logoutUser, requestPasswordReset, resetPassword, getProfile, updateProfile, changePassword, requestEmailChange, verifyEmailChange } from "./users";
import { getPreferences, savePreferences } from "./preferences";
// Aliased: `./users` already exports `getProfile` for the account profile
// (name, email). This one is the demographics/intent profile.
import { getProfile as getUserProfile, saveProfile as saveUserProfile } from "./profiles";
import { recordRecipeFeedback } from "./recipe-feedback";
import { getCurrentMenu, saveWeeklyMenu, generateServerMenu, swapServerMenuRecipe } from "./menus";
import { sendAssistantMessage } from "./assistant";
import {
  createShoppingList,
  getCurrentShoppingList,
  sendCurrentShoppingListEmail,
  getSupportedShoppingSupermarkets,
  updateShoppingListItem,
} from "./shopping-lists";
import { getGenericIngredientsByIds } from "./generic-ingredients";
import {
  createOrder,
  cancelOrder,
  getOrders,
  getOrderById,
  getCheckoutSession,
  getCheckoutSessionByOrder,
} from "./orders";
import { getAddresses, saveAddress, deleteAddress, autocompleteAddress } from "./addresses";

const logic = {
  // RECIPES
  getRecipes,
  getRecipeDetails,
  getAllRecipes,

  // USERS
  registerUser,
  loginUser,
  loginWithGoogle,
  completeOAuthLogin,
  isUserLoggedIn,
  logoutUser,
  requestPasswordReset,
  resetPassword,
  getProfile,
  updateProfile,
  changePassword,
  requestEmailChange,
  verifyEmailChange,

  // PREFERENCES
  getPreferences,
  savePreferences,

  // USER PROFILE (demographics + intent)
  getUserProfile,
  saveUserProfile,

  // RECIPE FEEDBACK
  recordRecipeFeedback,

  // MENUS
  getCurrentMenu,
  sendAssistantMessage,
  saveWeeklyMenu,
  generateServerMenu,
  swapServerMenuRecipe,

  // SHOPPING LISTS
  createShoppingList,
  getCurrentShoppingList,
  sendCurrentShoppingListEmail,
  getSupportedShoppingSupermarkets,
  updateShoppingListItem,
  getGenericIngredientsByIds,

  // ORDERS
  createOrder,
  cancelOrder,
  getOrders,
  getOrderById,
  getCheckoutSession,
  getCheckoutSessionByOrder,

  // ADDRESSES
  getAddresses,
  saveAddress,
  deleteAddress,
  autocompleteAddress,
};

export default logic;
